// src/router/salary.routes.js
import SalaryManagement from '@/components/features/salary/SalaryManagement.vue';
import SalaryStatements from '@/components/features/salary/SalaryStatements.vue';
import SalaryPaymentCreate from '@/components/features/salary/SalaryPaymentCreate.vue';
import SalaryRewardCreate from '@/components/features/salary/SalaryRewardCreate.vue';
import SalaryDeductionCreate from '@/components/features/salary/SalaryDeductionCreate.vue';
import SalaryPaymentEdit from '@/components/features/salary/SalaryPaymentEdit.vue';
import SalaryCalculationsIndex from '@/components/features/salary/SalaryCalculationsIndex.vue';
import SalaryCalculationDetail from '@/components/features/salary/SalaryCalculationDetail.vue';
import EmployeeSalarySheet from '@/components/features/salary/EmployeeSalarySheet.vue';
import TeacherSalarySheet from '@/components/features/salary/TeacherSalarySheet.vue';
import SalaryTypeReceipts from '@/components/features/salary/SalaryTypeReceipts.vue';

export default [
  {
    path: '/salary-management',
    name: 'salary.management',
    component: SalaryManagement,
    meta: {
      title: 'salary_management.title',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
    children: [
      {
        path: 'create-payment',
        name: 'salaries.createPayment',
        component: SalaryPaymentCreate,
        meta: {
          title: 'salary_management.add_payment',
          requiresAuth: true,
          requiredPerm: 'salary_management.create',
          hideBreadcrumb: true
        },
      },
    ],
  },
  {
    // Standalone (not nested under /salary-management) for the same reason
    // as create-reward/create-deduction above — nesting would always drag in
    // the real "إدارة الرواتب" ancestor. This one route is shared by
    // salary/on_account/reward/deduction edits; the caller passes
    // ?type=reward|deduction so the breadcrumb can point back to the right
    // list. With no (or unrecognized) type, breadcrumbParents resolves to an
    // empty array and no breadcrumb bar renders — matching the previous
    // behavior for salary/on_account edits.
    path: '/salary-management/receipts/:id/edit',
    name: 'salaries.editReceipt',
    component: SalaryPaymentEdit,
    props: true,
    meta: {
      title: 'salary_management.edit_receipt',
      requiresAuth: true,
      requiredPerm: 'salary_management.update',
      breadcrumbParents: (route) => {
        if (route.query.type === 'reward') {
          return [{ name: 'salary.rewardsList', title: 'sidebar.salary_rewards' }];
        }
        if (route.query.type === 'deduction') {
          return [{ name: 'salary.deductionsList', title: 'sidebar.salary_deductions' }];
        }
        return [];
      },
    },
  },
  {
    // Standalone (not nested under /salary-management) so the breadcrumb
    // trail only shows "المكافآت > إضافة مكافأة" — as a child route it would
    // also drag in the real "إدارة الرواتب" ancestor, which is exactly what
    // should NOT appear here.
    path: '/salary-management/create-reward',
    name: 'salaries.createReward',
    component: SalaryRewardCreate,
    meta: {
      title: 'salary_management.add_reward',
      requiresAuth: true,
      requiredPerm: 'salary_management.create',
      breadcrumbParents: [
        { name: 'salary.rewardsList', title: 'sidebar.salary_rewards' },
      ],
    },
  },
  {
    path: '/salary-management/create-deduction',
    name: 'salaries.createDeduction',
    component: SalaryDeductionCreate,
    meta: {
      title: 'salary_management.add_deduction',
      requiresAuth: true,
      requiredPerm: 'salary_management.create',
      breadcrumbParents: [
        { name: 'salary.deductionsList', title: 'sidebar.salary_deductions' },
      ],
    },
  },
  {
    path: '/salary/statements',
    name: 'salary.statements',
    component: SalaryStatements,
    meta: {
      title: 'salary_management.statements',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
  {
    path: '/salary/calculations',
    name: 'salary.calculations',
    component: SalaryCalculationsIndex,
    meta: {
      title: 'salary_management.calculations_title',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
  {
    path: '/salary/calculations/:id',
    name: 'salary.calculationDetail',
    component: SalaryCalculationDetail,
    props: true,
    meta: {
      title: 'salary_management.calculation_detail_title',
      breadcrumbParents: [
        { name: 'salary.calculations', title: 'salary_management.calculations_title' },
      ],
      requiresAuth: true,
      requiredPerm: 'salary_management.display'
    },
  },
  {
    path: '/salary/sheets/employees',
    name: 'salary.employeeSheet',
    component: EmployeeSalarySheet,
    meta: {
      title: 'salary_management.employee_sheet_title',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
  {
    path: '/salary/sheets/teachers',
    name: 'salary.teacherSheet',
    component: TeacherSalarySheet,
    meta: {
      title: 'salary_management.teacher_sheet_title',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
  {
    path: '/salary/rewards',
    name: 'salary.rewardsList',
    component: SalaryTypeReceipts,
    props: { type: 'reward' },
    meta: {
      title: 'sidebar.salary_rewards',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
  {
    path: '/salary/deductions',
    name: 'salary.deductionsList',
    component: SalaryTypeReceipts,
    props: { type: 'deduction' },
    meta: {
      title: 'sidebar.salary_deductions',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
  {
    path: '/salary/dashboard',
    name: 'salary.dashboard',
    component: () => import('@/components/features/salary/SalaryDashboard.vue'),
    meta: {
      title: 'salary_management.dashboard_title',
      requiresAuth: true,
      requiredPerm: 'salary_management.display',
      hideBreadcrumb: true
    },
  },
];
